import { render, staticRenderFns } from "./ExperimentListPage.vue?vue&type=template&id=2473ba6e&scoped=true&"
import script from "./ExperimentListPage.vue?vue&type=script&lang=js&"
export * from "./ExperimentListPage.vue?vue&type=script&lang=js&"
import style0 from "./ExperimentListPage.vue?vue&type=style&index=0&id=2473ba6e&scoped=true&lang=css&"
import style1 from "./ExperimentListPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2473ba6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAppBar,VBtn,VIcon,VMain,VTab,VTabItem,VTabs,VTabsItems})
